import './css/bill.css';

import moment from 'moment';

import React, { useEffect, useState } from 'react';
import Util, { Data } from 'service/util';

import Protected from './Protected';

import BillListTable from './bill/BillListTable';
import Loading from './Loading';
import ModalScreen from './ModalScreen';
import RecalcBillModal from './bill/RecalcBillModal';
import SYSChangeBalanceModal from './sys/SYSChangeBalanceModal';

const today = moment();

const BillList = ({owner, vehicle, bills, payments, last_payment, balance, ...props}) =>
{
  if (!props.onUpdated) throw new Error(`[${BillList.name}] onUpdated must be specified`);

  const [modal, setModal]                 = useState(null);
  const [sel_vehicle, setVehicle]         = useState(vehicle||null);
  const [sel_company, setFilteredCompany] = useState('');

  const [next_due, setNextDueDate]        = useState(null);
  const [statement, setStatementBalance]  = useState(0);

  const showRecalBillModal = () =>
  {
    let modal =
      <ModalScreen title="重新結算賬單" show={true} onClose={e=>setModal(null)}>
        <RecalcBillModal owner={owner}
          onUpdated={props.onUpdated}
          closeModal={e=>setModal(null)}
        />
      </ModalScreen>;
    setModal(modal);
  }
  const SYS_showChangeBalanceModal = () =>
  {
    let modal =
      <ModalScreen title="管理員" color="red" show={true} onClose={e=>setModal(null)}>
        <SYSChangeBalanceModal owner={owner}
          onUpdated={props.onUpdated}
          closeModal={e=>setModal(null)}
        />
      </ModalScreen>;
    setModal(modal);
  }

  const getL2Class = (v) =>
  {
    if (null === sel_vehicle && null === v)
      return 'tag license selected';
    if (null === sel_vehicle || null === v)
      return 'tag license';
    if (sel_vehicle.cd_license === v.cd_license)
      return 'tag license selected';
    return 'tag license';
  }

  //-------------------------------------
  // init
  useEffect(() =>
  {
    if (!bills) {
      setNextDueDate(null);
      setStatementBalance(0);
      return;
    }

    // set filter
    let com = bills[0]?.company;
    if (com) setFilteredCompany(com);

    // calc next bill date
    let nxtDue = bills
      .filter(x => !x.qualified && today.isBefore(x.due_dtm))
      .reduce((r,x) => r?.isBefore(x.due_dtm) ? r : moment(x.due_dtm), null)
      ?? today;
    setNextDueDate(nxtDue);

    // calc should paid total
    let bstt = bills.reduce((r,x) => (x.qualified || nxtDue.isBefore(x.due_dtm)) ? r : r + x.amount - x.discount, 0)??0;
    setStatementBalance(Math.max(0, bstt - balance));

  }, [bills]);

  useEffect(() => {
    setVehicle(vehicle||null);
  }, [vehicle]);

  // const autoCheckBills = () =>
  // {
  //   API.checkBills(owner.id).then(resp => {
  //     props.onUpdated();
  //   });
  // }

  return (
    <div className="box" id="tbl-service-charge">
      <h4 className="box-head">收費</h4>
      <div className="box-body">
        <select value={sel_company} className="s-company"
                onChange={e=> setFilteredCompany(e.target.value) }>
          <option value="">全部</option>
          { Data.company.map(com=>
            <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
          )}
        </select>
        <div className="flex tbl-license">
          { owner.vehicles?.length > 1 &&
            <span onClick={e=>setVehicle(null)}
                  className={getL2Class(null)}>總計</span>
          }
          { owner.vehicles?.map(v=>
              <span onClick={e=>setVehicle(v)} key={v.cd_license}
                    className={getL2Class(v)}
              >{ v.cd_license }</span>
            )
          }
        </div>
        { !bills
          ?<Loading small={true} />
          :<BillListTable bills={bills}
            vehicle={sel_vehicle}
            company={sel_company}
            onUpdated={props.onUpdated}
          />
        }
        <div>上次繳款日期：{ Util.ShortDate(last_payment) }</div>
        <div>上期已付餘額：$ { Util.nf2(balance) }</div>
        <div>下期繳款日期：{ Util.ShortDate(next_due) }</div>
        <div>下期應繳費用：$ { Util.nf2(statement) }</div>
        <Protected allow={['ADMIN','OPERATOR']}>
          <div className="action-panel">
            <div>
              <Protected>
                <button className="btn red" onClick={SYS_showChangeBalanceModal}>手動更改餘額</button>
              </Protected>
            </div>
            <div className="button-group">
              {/* balance>0 &&
                <button type="button" className="btn blue"
                  onClick={autoCheckBills}
                >自動結賬</button>
              */}
              <button className="btn red" onClick={showRecalBillModal}>結算</button>
            </div>
          </div>
        </Protected>
      </div>
      { modal }
    </div>
  );

} // end class

export default BillList;